import API from "api/base/base";

const Outcomes = new API({ controller: "outcomes" });

Object.assign(Outcomes, {});

export default Outcomes;
